import React from 'react';
import styled, { ThemeProvider } from 'styled-components';

import Layout from '../layout';
import lightTheme from '../themes/light';
import withSentry from '../utils/withSentry';
import withi18n from '../utils/withI18n';
import { getLabel } from '../utils/i18n';

import GetBaseInitialProps from '../network/GetBaseInitialProps';
import makeOrCacheApiReq from '../utils/apiCache';
import redirectToMobileSite from '../utils/redirectToMobileSite.mjs';
import { getUrlParam } from '../utils/urlUtils';
import API_PATH from '../actions/actionsFactory/apiPath';
import { gwGet } from '../actions/actionsFactory/gwRequest';
import { setRefSwitchInfo, setRegisterOpenStatus } from '../actions/actionsSet/common';
import { setCheckIpResult } from '../actions/actionsSet/country';
import metaInfo from '../config/metaInfo';

import FlexBox from '../components/FlexBox';
import Register from '../components/Register';

const { REF_SWITCH_API_PATH, GET_REGISTER_OPEN_STATUS, CHECK_IP_API_PATH } = API_PATH;

const { brands } = metaInfo;

const Card = styled(FlexBox)`
  width: 100%;
  max-width: 460px;
`;

type Props = {
  metaData?: Object,
  url?: Object,
  i18n?: Object,
  locale?: string,
  railCode: string,
  hostName: string,
};

export default
@withSentry
@withi18n
class RegisterPage extends React.Component<Props> {
  static defaultProps = {
    metaData: {},
    url: {},
    i18n: {},
    locale: 'en',
  };

  static getInitialProps = async ctx => {
    const initProps = await GetBaseInitialProps(ctx, { withProductsData: false });
    const { req, store } = ctx;
    const promises = [];

    promises.push(
      makeOrCacheApiReq(REF_SWITCH_API_PATH, () => gwGet(REF_SWITCH_API_PATH, null, req, false))
    );

    promises.push(
      makeOrCacheApiReq(GET_REGISTER_OPEN_STATUS, () => gwGet(GET_REGISTER_OPEN_STATUS, null, req, false)
      )
    );

    promises.push(
      makeOrCacheApiReq(CHECK_IP_API_PATH, () => gwGet(CHECK_IP_API_PATH, null, req, false))
    );

    const [...responses] = await Promise.all(promises);

    const refSwitchInfo = responses.shift();
    store.dispatch(setRefSwitchInfo(refSwitchInfo.data));

    const registerOpenStatus = responses.shift();
    store.dispatch(setRegisterOpenStatus(registerOpenStatus.data));

    const isAllowed = responses.shift();
    store.dispatch(setCheckIpResult(isAllowed.data));

    return {
      ...initProps,
    };
  };

  componentDidMount() {
    const ref = getUrlParam('ref');
    redirectToMobileSite(false, null, null, '/m-register.html', ref);
  }

  render() {
    const {
      url, locale, metaData, i18n, hostName,
    } = this.props;

    return (
      <ThemeProvider theme={lightTheme}>
        <Layout
          privacyDisplay={true}
          url={url}
          locale={locale}
          hostName={hostName}
          metaData={{
            ...metaData,
            title: `${getLabel('exchange-register-title', i18n)} | Registration |${brands[locale]}`,
            description: getLabel('exchange-register-description', i18n),
          }}
          isGreyBg={true}
          commonContent={true}
          omitFooterTotalUpdate={true}
        >
          <Card>
            <Register />
          </Card>
        </Layout>
      </ThemeProvider>
    );
  }
}
